import { render } from "./goodStanding.vue?vue&type=template&id=66bf7b2d"
import script from "./goodStanding.vue?vue&type=script&lang=js"
export * from "./goodStanding.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__